// extracted by mini-css-extract-plugin
export var container = "style-module--container--df6f4";
export var description = "style-module--description--e98bf";
export var headline = "style-module--headline--871db";
export var pcCarousel = "style-module--pcCarousel--bad16";
export var section = "style-module--section--b5e6e";
export var tabCarousel = "style-module--tabCarousel--df078";